import { IContractDetailState } from '../../types/contracts/contractTypes';
import endpoints from '../../utils/commonVariables/endpoints';
import {
    savableEntities,
    viewModelEntities,
} from '../../utils/commonVariables/entityKeys';
import { contractDetailViewModel } from '../../utils/contractUtils/contractUtils';
import { convertToOvariant } from '../../utils/convertToOvariant';
import api from '../api';
import { adaptStaticRateContractToDDBB } from './contractDetailAdapters';

export const getContractDetailData = async (idContract: string) => {
    const endpoint = endpoints.viewModel(
        viewModelEntities.StaticRateContract,
        idContract
    );

    return api.post(endpoint, contractDetailViewModel);
};

export const saveContractData = async (
    contractData: Partial<IContractDetailState>
) => {
    const adaptedData = adaptStaticRateContractToDDBB(contractData);
    const objectToSend = convertToOvariant(
        savableEntities.StaticRateContract,
        adaptedData,
        adaptedData.Id,
        contractDetailViewModel
    );
    return api.post(endpoints.commonSave, objectToSend);
};
